<template>
  <div class="info">
    <lb-table
      v-loading="loading"
      v-horizontal-scroll="'always'"
      :column="columns"
      :data="page.list"
      pagination
      :total="page.totalNum"
      layout="total, sizes, prev, pager, next, jumper"
      :page-sizes="[5, 10, 20, 30, 50]"
      :current-page.sync="page.currentPage"
      :page-size="page.pageSize"
      @selection-change="onMultipleSelection"
      @size-change="handleSizeChange"
      @p-current-change="handleCurrentChange"
    >
    </lb-table>
  </div>
</template>
<script>
import LbTable from '../../../components/lb-table/lb-table'
export default {
  props: {
    id: {
      type: String,
      default: ''
    },
  },
  components: {
    LbTable
  },
  data () {
    return {
      name: 'cdd',
      list: [{}, {}],
      columns: [
        { label: '订单编号', prop: 'orderNo', minWidth: '120' },
        { label: '收货人姓名', prop: 'postName', minWidth: '220' },
        { label: '收货人电话', prop: 'postPhone', minWidth: '120' },
        { label: '下单时间', prop: 'orderTime', minWidth: '120' },
        { label: '订单价格', prop: 'receivableAmount', minWidth: '120' },
        {
          label: '订单状态', prop: 'statusLabel', minWidth: '120',
          render: (h, scope) => {
            let vv = ''
            if (scope.row.statusLabel == '已收货') {
              vv = <p style="color:#666666;font-size:14px;display:flex"><div style="width: 10px;height: 10px;background: #12AB62;border-radius: 50%;opacity: 1;margin-top:7px;margin-right:4px;margin-left:10px"></div>
                <div>{scope.row.statusLabel}</div>
              </p>
            } else {
              vv = <p style="color:#666666;font-size:14px;display:flex"><div style="width: 10px;height: 10px;background: #FF9226;border-radius: 50%;opacity: 1;margin-top:7px;margin-right:4px;margin-left:10px"></div>
                <div>{scope.row.statusLabel}</div>
              </p>
            }

            return (
              <div style="margin-left:40px"> {vv}</div>
            )

          }
        },
        { label: '订单类型', prop: 'orderTypeLabel', minWidth: '120' },
        {
          label: '操作',
          minWidth: '180',
          fixed: 'right',
          render: (h, scope) => {
            return (
              <div style="cursor:pointer;color:#4168E7" onClick={() => { this.look(scope.row) }}>
                查看
              </div>
            )
          }
        }],
      page: { list: [], pageNo: 1, pageSize: 10, totalNum: 0, currentPage: 1, status: '' },
      loading: true
    }
  },
  watch: {
    id (val, vall) {
      this.id = val
    },
  },
  created () {
    this.fetchData()
  },
  methods: {
    look (row) {
      this.$router.push({
        name: 'platformIogisticsOrderDetail',
        query: {
          id: row.id,
          // status: row.status
        }
      })
    },
    onMultipleSelection (val) {
      this.selectionGoods = val
    },
    handleCurrentChange (currentChange) {
      this.page.pageNo = currentChange
      this.fetchData()
    },
    handleSizeChange (sizeChange) {
      this.page.pageSize = sizeChange
      this.fetchData()
    },
    fetchData () {
      let data = {
        userId: this.id,
        pageNo: this.page.pageNo,
        pageSize: this.page.pageSize
      }
      this.$api.getUserOrderPageList(data).then(res => {
        this.page.list = res.data.list
        this.page.totalNum = res.data.totalNum
        this.loading = false
      })
    }
  }
}
</script>
<style scoped>
.info {
  padding-top: 20px;
  padding-bottom: 20px;
}
</style>

